import React from "react";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
import { userView } from "../../../../api/user";
import LabeledEntry from "../../../helpers/LabeledEntry";
import { userEmailDelete, userEmailView } from "../../../../api/useremail";
import { Button, Stack, styled } from "@mui/material";
import { testSessionLoader } from "../../../../loaders/helpers";
import useInfoSnackbar from "../../../../hooks/useInfoSnackbar";
import EmailUserDisplay from "./EmailUserDisplay";
import ConfirmationContainer from "../../../helpers/ConfirmationContainer";

const StyledEntryContainer = styled(Stack)`
  gap: 1em;
  width: 80%;
  padding: 2em 0 4em;
`;

const StyledButtonContainer = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4em;
`;

const emailLoader = async (params) => {
  await testSessionLoader(params);
  const userEmailEntityId = params.params.id;
  const userEmailRes = await userEmailView(userEmailEntityId);
  const userEmail = userEmailRes.data;
  const userEntityId = userEmail.userEntityId;
  const userRes = await userView(userEntityId);
  const user = userRes.data;
  return { userEmail, user };
};

const Email = () => {
  const { userEmail, user } = useRouteLoaderData("adminUserEmail");
  const infoSnackbar = useInfoSnackbar();
  const navigate = useNavigate();

  const handleDeleteConfirmed = async () => {
    const res = await userEmailDelete(userEmail.userEmailEntityId);
    if (res.code === "SUCCESS") {
      infoSnackbar.alertSuccess(res.message);
      navigate(-1);
    } else {
      infoSnackbar.alertError(res.message);
    }
  };

  const placeholder = "Not Specified";

  const canDelete = userEmail.userEmailEntityId !== user.userEmailEntityId;

  return (
    <>
      <StyledEntryContainer>
        <EmailUserDisplay user={user}/>
        <LabeledEntry
          label="Email"
          value={userEmail.email}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Create Date"
          value={userEmail.createDate}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Last Modified"
          value={userEmail.modifyDate}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Validation Date"
          value={userEmail.validationDate}
          placeholder={"Not Validated"}
        />
        <LabeledEntry
          label="User Email Entity ID"
          value={userEmail.userEmailEntityId}
          placeholder={placeholder}
        />
      </StyledEntryContainer>
      {canDelete && <StyledButtonContainer>
        <ConfirmationContainer
          dialogTitle="Confirm Email Deletion"
          dialogMessage={`Are you sure that you want to delete this email: "${userEmail.email}"?`}
          onConfirmed={handleDeleteConfirmed}
        >
          <Button
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </ConfirmationContainer>
      </StyledButtonContainer>}
    </>
  );
};

export { emailLoader };
export default Email;